import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Cookies from 'universal-cookie';
import { RenderField, RenderSubmitButton } from '../../../common/form';
import GuestRequestAccess from './GuestRequestAccess';
import * as Validations from '../../../common/form/commonValidations';
// import { guestSearch, resetGuestSearch, getRsvpByGuestUuid } from '../../../../actions/PublicWebsiteActions';
import { guestSearch, resetGuestSearch, getRsvpByGuestUuid, revealAccessForm, hideAccessForm } from '../../../../actions/PublicWebsiteActions';
import GuestSearchResults from './GuestSearchResults';


function RsvpPageHeader({ page, rsvpAccessForm, guestRequestSubmitted, onHideAccessForm }) {
  return (
    <div className={`cms-page-header${(!page.description && !page.header_image_url) || !page.title ? ' flex-container' : ''}`}>
      <div className={rsvpAccessForm ? '' : 'cms-header-accent-top-left'} />
      <div className="cms-header-accent-top-right" />
      <div className="cms-header-accent-bottom-left" />
      <div className="cms-header-accent-bottom-right" />
      {/* default state - rsvp page title, whatever it is. */}
      <div>
        {(!rsvpAccessForm && !guestRequestSubmitted) &&
          <h1 className="for-small-laptops">{page.title}</h1>
        }
        {/* request form state */}
        {(rsvpAccessForm && !guestRequestSubmitted) &&
          <div>
            <div className="back-btn text-left" onClick={() => onHideAccessForm()}>‹ Back to RSVP</div>
            <h1>RSVP Request</h1>
          </div>
        }
        {(guestRequestSubmitted && rsvpAccessForm) &&
          <h1>Your Request Has Been Sent</h1>
        }
        {page.header_image_url && (
          <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
        )}
        {(page.description && !guestRequestSubmitted && !rsvpAccessForm) && (
          <p className={`page-description${page.header_image_url ? ' has-image-above' : ''}`}>{page.description}</p>
        )}
      </div>
    </div>
  );
}

RsvpPageHeader.propTypes = {
  page: PropTypes.shape({}),
  rsvpAccessForm: PropTypes.bool,
  guestRequestSubmitted: PropTypes.bool,
  onHideAccessForm: PropTypes.func
};

class GuestLookupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rsvpSearchDisabled: false,
      revealAccessForm: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.enableSearch = this.enableSearch.bind(this);
  }

  componentWillMount() {
    this.updateDisableSearch();
  }

  componentWillReceiveProps(nextProps) {
    const { submitting, submitSucceeded } = nextProps; // eslint-disable-line
    if (this.props.submitting && !submitting && submitSucceeded) {
      if (nextProps.guestSearchResults.length > 1) {
        this.handleScroll(this.scrollTarget);
      } else if (nextProps.guestSearchResults.length === 1) {
        if (nextProps.guestSearchResults[0].suggested) {
          this.handleScroll(this.scrollTarget);
        }
      }
    }
    this.updateDisableSearch();
  }

  componentWillUnmount() {
    this.props.resetSearch();
    clearTimeout(this.enableSearchTimeoutId);
  }

  handleScroll(el) {
    if (el) {
      const { y } = el.getBoundingClientRect();
      if (y > 120) {
        window.scrollTo(0, y - 100);
      }
    }
  }

  enableSearch() {
    this.setState({ rsvpSearchDisabled: false });
  }

  updateDisableSearch() {
    const cookies = new Cookies();
    const rsvpSearchDisabledUntil = parseInt(cookies.get('rsvpSearchDisabled'), 10);
    const rsvpSearchDisabled = !!rsvpSearchDisabledUntil;

    if (rsvpSearchDisabled) {
      const timeNow = (new Date()).getTime();
      this.enableSearchTimeoutId = setTimeout(this.enableSearch, rsvpSearchDisabledUntil - timeNow);
      window.scrollTo(0, 0);
    }

    this.setState({ rsvpSearchDisabled });
  }

  render() {
    const { rsvpSearchDisabled } = this.state;
    const { page, guestSearchResults, handleSubmit, pristine, valid, onRevealAccessForm, rsvpAccessForm, guestRequestSubmitted, rsvpRequestEnabled, onHideAccessForm } = this.props;
    const notFound = guestSearchResults[0] === 'NOT_FOUND';
    const searchResults = rsvpSearchDisabled ? ['DISABLED'] : guestSearchResults;
    const disabledCls = rsvpSearchDisabled ? 'disabled-rsvp-form' : '';

    return (
      <div>
        <RsvpPageHeader page={page} rsvpAccessForm={rsvpAccessForm} guestRequestSubmitted={guestRequestSubmitted} onHideAccessForm={onHideAccessForm} />
        {!rsvpAccessForm ? (
          <div className="entity-sections rsvp-sections">
            <div className="entity-sections-accent-top-left" />
            <div className="entity-sections-accent-top-right" />
            <div className="entity-sections-accent-bottom-left" />
            <div className="entity-sections-accent-bottom-right" />
            <div className="entity-section">
              <div className={disabledCls}>
                {!rsvpSearchDisabled && (
                <div>
                  <div className="row">
                    <p ref={(el) => { this.scrollTarget = el; }} className="rsvp-paragraph">
                      <span>Please enter your first and last name to unlock your RSVP form.</span><span> If you&#39;re responding for you and a guest (or your family),</span><span> you&#39;ll be able to RSVP for your entire group.</span>
                    </p>
                    <form onSubmit={handleSubmit} className="name-lookup-form-v2">
                      <div className="col-xs-12 col-sm-6 col-sm-offset-2 col-md-6 col-md-offset-2">
                        <Field
                          name="name"
                          className={notFound ? 'error-state' : ''}
                          type="text"
                          id="rsvp-name-lookup"
                          component={RenderField}
                          placeholder="Ex. Sarah Fortune (not The Fortune Family or Dr. & Mr. Fortune)"
                          validate={Validations.REQUIRED}
                        />
                      </div>
                      <div className="col-xs-12 col-sm-3 col-md-2">
                        <RenderSubmitButton pristine={pristine} valid={valid} className="guest-lookup-cta" value="Continue" />
                      </div>
                    </form>
                  </div>
                </div>
                )}
                <GuestSearchResults searchResults={searchResults} onRevealAccessForm={onRevealAccessForm} rsvpRequestEnabled={rsvpRequestEnabled} />
              </div>
            </div>
          </div>
        ) : (
          <GuestRequestAccess />
        )}
      </div>
    );
  }
}

GuestLookupForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  guestSearchResults: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape({}))
  ]),
  submitting: PropTypes.bool,
  page: PropTypes.shape({}),
  onRevealAccessForm: PropTypes.func,
  rsvpAccessForm: PropTypes.bool,
  guestRequestSubmitted: PropTypes.bool,
  rsvpRequestEnabled: PropTypes.bool,
  onHideAccessForm: PropTypes.func
};

const mapStateToProps = state => ({
  guestSearchResults: state.publicWebsite.guestSearch,
  page: state.publicWebsite.page,
  slug: state.publicWebsite.wedding.slug,
  rsvpAccessForm: state.publicWebsite.rsvpAccessForm,
  guestRequestSubmitted: state.publicWebsite.guestRequestSubmitted,
  rsvpRequestEnabled: state.publicWebsite.wedding.enable_rsvp_requests,

});

const mapDispatchToProps = dispatch => ({
  onSubmit: guestSearchRequest => dispatch(guestSearch(guestSearchRequest.name)).then((json) => {
    if (json.length === 1 && !json[0].suggested) {
      dispatch(getRsvpByGuestUuid(json[0].uuid));
    }
  }),
  resetSearch: () => dispatch(resetGuestSearch()),
  onRevealAccessForm: () => dispatch(revealAccessForm()),
  onHideAccessForm: () => dispatch(hideAccessForm())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'GuestLookupForm'
})(GuestLookupForm));



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/GuestLookupForm.jsx
 **/